import { ReportReviewerStatus, useGetReportReviewersQuery } from "@api/graphql/types-and-hooks";
import { useIsPeerReviewEnabled } from "@components/QaReview/hooks/useIsPeerReviewEnabled";
import { useIsApprovalRequired } from "@components/ReportReview/hooks/useIsApprovalRequired";
import { useReportOptional } from "@providers/ReportProvider";

/** `refetchInterval` keeps the list current for a viewer who has no push for reviewer status changes. */
export const useReportReviewers = ({ refetchInterval }: { refetchInterval?: number } = {}) => {
  const reportId = useReportOptional()?.report?.id;

  const isPeerReviewEnabled = useIsPeerReviewEnabled() && !!reportId;
  const isApprovalRequired = useIsApprovalRequired();

  const { data, isSuccess, isError } = useGetReportReviewersQuery(
    { reportId: reportId ?? "" },
    {
      enabled: (isPeerReviewEnabled || isApprovalRequired) && !!reportId,
      refetchInterval: isPeerReviewEnabled ? refetchInterval : undefined,
    },
  );
  const reviewers = (data?.getReportReviewers ?? []).filter(({ status }) => status !== ReportReviewerStatus.Withdrawn);
  return {
    reviewers,
    isLoaded: isSuccess,
    isError,
  };
};
